import moment from "moment";

export function secondsToMinutesString(seconds: number) {
  let mins = Math.ceil(seconds / 60);
  let secs = Math.round(seconds % 60);
  if (mins!=0)
    return `${mins} mins, ${secs} secs.`;
   else
    return `${secs} secs.`;
}
export function decodeQueryString(text: string): any {
  let url = decodeURIComponent(text);
  let startIndex = url.indexOf("?");
  if (startIndex == -1)
    return null;

  let parameters = text.substring(startIndex + 1).split('&');


  let ret = {};
  for (var i = 0; i < parameters.length; i++) {
    let p = parameters[ i ].split('=');
    ret[ decodeURIComponent(p[ 0 ]) ] = decodeURIComponent(p[ 1 ]);
  }

  return ret;

}

export function getDownloadFileName(file: string) {
  let index = file.lastIndexOf('.');
  let ext = "";
  let name = file;
  if (index >= 0) {
    name = file.substring(0, index );
    ext = "."+file.substring(index+1);
  }
  let date = moment().format("yyyy-MM-DD HH-mm-ss a");
  return `${name} ${date}${ext}`;

}

export function encodeQueryString(data: any) {
  let ret = "";
  for (let p in data) {
    ret += `${encodeURIComponent(p)}=${encodeURIComponent(data[ p ])}&`;
  }
  return ret;
}

export function longDateFormat(date: string) {
  if (!date)
    return "";

  return moment(date).format("MM/DD/yyyy - hh:mm:ss a")
}

export function getHoursOrMinutes(minutes: number): { value: number, unit: string } {
  if (!minutes)
    return null;
  let ret = {
    value: minutes,
    unit: 'm'
  };

  let value = minutes % 60;
  if (value == 0) {
    ret.value = minutes / 60;
    ret.unit = 'h';
  }
  return ret;
}
